import type { CaptureContext } from './types'

/** `?relatie=contact:<id>` or `organisatie:<id>`; anything else is no context. */
export function parseRelation(value: string | null): CaptureContext | null {
  const match = /^(contact|organisatie):([0-9a-fA-F-]{8,})$/.exec(value ?? '')
  return match ? { type: match[1] as CaptureContext['type'], id: match[2] as string } : null
}

export function relationPath(context: CaptureContext | null): string {
  if (!context) return '/relaties/overzicht'
  return context.type === 'contact'
    ? `/relaties/contacten/${context.id}`
    : `/relaties/organisaties/${context.id}`
}

/** The `?relatie=` value that starts a memo about a relation. */
export function inspreekenHref(context: CaptureContext): string {
  return `/relaties/inspreken?relatie=${context.type}:${context.id}`
}
